import { CornerIcon, FoulIcon, FreeKickIcon, RedCardIcon, YellowCardIcon } from '@/common/assets';
import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { RowComparisonEvent, TeamsJerseys } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';
import toFixedOrInteger from '../../../utils/toFixedOrInteger';

const rowHeightClassName = 'h-[40px]';
const columnWidthClassName = 'w-[54px]';

const AverageMatchStats = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.AVERAGE_MATCH_STATS,
  });

  if (!widget || widget.type !== ApiWidgetType.AVERAGE_MATCH_STATS || !widget?.data) {
    return null;
  }

  const { home: homeStats, away: awayStats } = widget.data;

  return (
    <Section
      name={translate('PreMatchStats.AveragePerMatch')}
      contentClassName="flex flex-col gap-2"
    >
      <TeamsJerseys
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
      />
      <RowComparisonEvent
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.YellowCards')}
        homeNumber={toFixedOrInteger(homeStats.yellowCards, 1)}
        awayNumber={toFixedOrInteger(awayStats.yellowCards, 1)}
        icon={<YellowCardIcon />}
      />
      <RowComparisonEvent
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.RedCards')}
        homeNumber={toFixedOrInteger(homeStats.redCards, 1)}
        awayNumber={toFixedOrInteger(awayStats.redCards, 1)}
        icon={<RedCardIcon />}
      />
      <RowComparisonEvent
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.Freekicks')}
        homeNumber={toFixedOrInteger(homeStats.freeKicks, 1)}
        awayNumber={toFixedOrInteger(awayStats.freeKicks, 1)}
        icon={<FreeKickIcon />}
      />
      <RowComparisonEvent
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.Corners')}
        homeNumber={toFixedOrInteger(homeStats.corners, 1)}
        awayNumber={toFixedOrInteger(awayStats.corners, 1)}
        icon={<CornerIcon />}
      />
      <RowComparisonEvent
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.Fouls')}
        homeNumber={toFixedOrInteger(homeStats.fouls, 1)}
        awayNumber={toFixedOrInteger(awayStats.fouls, 1)}
        icon={<FoulIcon />}
      />
    </Section>
  );
};

export default AverageMatchStats;
